import { handleFileBrowserRequest } from '../../files/browser/index.js';
import { handleFileBrowserSearch } from '../../files/handle-file-browser-search.js';
import type {
  ApiToBridgeFileBrowserRequestMessage,
  ApiToBridgeFileBrowserSearchMessage,
} from '../../types/api-to-bridge-messages.js';
import type { MessageHandlerDeps } from '../message-handler-deps.js';

export function handleFileBrowserRequestMessage(
  msg: ApiToBridgeFileBrowserRequestMessage,
  { getWs, e2ee, sessionWorktreeManager }: MessageHandlerDeps,
): void {
  if (typeof msg.id !== 'string' || typeof msg.path !== 'string') return;
  const socket = getWs();
  if (!socket) return;
  handleFileBrowserRequest(msg, socket, e2ee, sessionWorktreeManager);
}

export function handleFileBrowserSearchMessage(
  msg: ApiToBridgeFileBrowserSearchMessage,
  { getWs, e2ee, sessionWorktreeManager }: MessageHandlerDeps,
): void {
  if (typeof msg.id !== 'string') return;
  const socket = getWs();
  if (!socket) return;
  handleFileBrowserSearch(
    msg as { id: string; type: 'file_browser_search'; q: string; sessionId?: string },
    socket,
    e2ee,
    sessionWorktreeManager,
  );
}
